function improveScrollingBehavior(): void {
  window.addEventListener('touchstart', touchStart);
  window.addEventListener('touchmove', preventTouch, { passive: false });

  let firstClientX = 0;
  let clientX = 0;

  function touchStart({ touches }: TouchEvent) {
    firstClientX = touches.item(0)?.clientX;
  }

  function preventTouch(event) {
    const minValue = 5; // threshold
    const [touch] = event.touches;

    clientX = touch.clientX - firstClientX;

    // Vertical scrolling does not work when you start swiping horizontally.
    if (Math.abs(clientX) > minValue) {
      event.preventDefault();
      event.returnValue = false;
      return false;
    }
  }
}

export function init() {
  improveScrollingBehavior();

  new (window as any).Swiper('.swiper', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    grabCursor: true,
    allowTouchMove: true,
    mousewheel: { forceToAxis: true },
    autoplay: {
      delay: 2000
    },
    loop: true,
  });
}
